import { createFileRoute } from "@tanstack/react-router";

import { WorkflowsView } from "../components/workflow/WorkflowsView";

export type WorkflowsSearch = {
  readonly project?: string;
  readonly workflow?: string;
};

export function validateWorkflowsSearch(search: Record<string, unknown>): WorkflowsSearch {
  return {
    ...(typeof search.project === "string" && search.project.length > 0
      ? { project: search.project }
      : {}),
    ...(typeof search.workflow === "string" && search.workflow.length > 0
      ? { workflow: search.workflow }
      : {}),
  };
}

export const Route = createFileRoute("/_chat/workflows")({
  validateSearch: validateWorkflowsSearch,
  component: WorkflowsView,
});
